import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeSanitize from 'rehype-sanitize';
import { Box } from '@mui/material';
import { FONT, RADIUS } from './lib/brand';

/**
 * Text written by a bot is untrusted. It is rendered as Markdown only: raw HTML
 * is dropped (no rehype-raw, skipHtml), the output goes through rehype-sanitize,
 * images are not rendered at all (no loading from unknown hosts), and every link
 * opens in a new tab with rel="noopener noreferrer". react-markdown's default URL
 * transform already strips javascript: and data: links.
 */
export function Markdown({ children }: { children: string }) {
  return (
    <Box
      data-testid="markdown"
      sx={{
        fontSize: 13, lineHeight: 1.55, wordBreak: 'break-word',
        '& p': { m: 0, mb: 0.8 }, '& p:last-child': { mb: 0 },
        '& ul, & ol': { my: 0.5, pl: 2.5 },
        '& code': { fontFamily: FONT.mono, fontSize: 12, bgcolor: 'action.hover', px: 0.5, borderRadius: RADIUS.sm },
        '& pre': { overflowX: 'auto', bgcolor: 'action.hover', p: 1, borderRadius: RADIUS.md },
        '& a': { color: 'primary.main' },
        '& h1, & h2, & h3, & h4': { fontSize: 14, m: 0, mb: 0.5, mt: 0.8 },
      }}
    >
      <ReactMarkdown
        skipHtml
        rehypePlugins={[rehypeSanitize]}
        components={{
          a: ({ href, children: c }) => <a href={href} target="_blank" rel="noopener noreferrer">{c}</a>,
          img: () => null,
        }}
      >
        {children}
      </ReactMarkdown>
    </Box>
  );
}
